export default "__VITE_ASSET__CMLkMMEf__"